import { usePageTracking } from '@/hooks/usePageTracking';

// Component that handles page tracking
export const PageTracker = () => {
  usePageTracking();
  return null;
};
